export default class ThingNotesController {}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-notes/thing-notes.controller.js